import dayjs from "./dayjs";
import { isValidNegativeNumberFormat, loadCustomStylesheet, setVariableByTemplate } from "@euroland/libs/utils";
import { number } from "@euroland/format-number";

import variableStyles from "../styles/variables-style.json";
import variableStylesCommon from "@euroland/react/dist/esm/scss/variables-style.json";

/*
 * get percent never lower than min value
 *
 * @param { number } min
 * @param { number } current
 * @param { number } max
 * @returns { number }
 */
export function softPercent(min, current, max) {
  if (current === 0) return 0;

  const percent = (current / max) * 100;
  const negativePercent = 100 - percent;
  const percentWithMin = (negativePercent / 100) * min;
  return percentWithMin + percent;
}

export function getLanguage() {
  var locale = window.appSettings?.language;
  if (!locale || !locale.length) {
    locale = "en-gb";
  }
  return locale;
}

/**
 *
 * @param { number | Date} value
 * @param { import('../..').CompanySetting } settings
 * @returns { import('dayjs').Dayjs }
 */
export function getDateTime(value, settings) {
  let timeZone = settings.timeZone;
  return dayjs.utc(value).tz(timeZone);
}

/**
 *
 * @param { Date} date
 * @param { string } timeFormat
 * @returns { string }
 */

export function formatTime(date, timeFormat) {
  if ((timeFormat.includes("ss") || timeFormat.includes("s"))
    && !timeFormat.includes("SSS")
    && date.millisecond() >= 500) {
    date = date.add(1, 'second');
  }
  return date;
}

/**
 *
 * @param { number | Date} value
 * @param { import('../..').CompanySetting } settings
 * @returns { string }
 */
export function formatDateTime(value, settings) {
  value = value || new Date();
  let formatDate = settings.format.longDate;
  let timeZone = settings.timezone;
  let dateJS = dayjs.utc(value);
  if ((formatDate.includes("ss") || formatDate.includes("s"))
    && !formatDate.includes("SSS") && dateJS.millisecond() >= 500) {
    dateJS = dateJS.add(1, 'second');
  }

  return dateJS.tz(timeZone).format(formatDate);
}

/**
 *
 * @param { number } value
 * @param { import("../..").IFormatSetting } param1
 * @returns { string }
 */
export function formatNumber(value, { decimalDigits, decimalSeparator, thousandsSeparator }) {
  var dec_point = decimalSeparator,
    thousands_sep = thousandsSeparator;
  value = (value + "").replace(/[^0-9+\-Ee.]/g, "");
  var n = !isFinite(+value) ? 0 : +value,
    prec = !isFinite(+decimalDigits) ? 0 : Math.abs(decimalDigits),
    sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
    dec = typeof dec_point === "undefined" ? "." : dec_point,
    s = "",
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return "" + Math.round(n * k) / k;
    };
  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || "").length < prec) {
    s[1] = s[1] || "";
    s[1] += new Array(prec - s[1].length + 1).join("0");
  }
  return s.join(dec);
}

/**
 *
 * @param { number } value
 * @param { import("../..").IFormatSetting} format
 * @returns
 */
export function convertNumber(value, format) {
  return formatNumber(value, { ...format, decimalDigits: 0 });
}

/**
 * @param {{
* decimalDigits: import("../..").IFormatSetting['decimalDigits']
* decimalSeparator: import("../..").IFormatSetting['decimalSeparator']
* thousandsSeparator:import("../..").IFormatSetting['thousandsSeparator']
* }} param
* @returns
*/
export const convertFormatNumber = ({ decimalDigits = 0, decimalSeparator = ".", thousandsSeparator = "," }) => {
  switch (decimalDigits) {
    case 0:
      return `#,##0`;
    default:
      return `#,##0.${Array.from({ length: decimalDigits }).reduce(
        s => `${s}0`,
        ""
      )}`;
  }
};

/**
 *
 * @param { number } value
 * @param { import("../..").IFormatSetting } format
 * @returns { string }
 */
export function convertNumberDecimal(value, format) {
  // if (value < 0) {
  //   let numberFormated = formatNumber(Math.abs(value), format);
  //   return formatNegativeNumber(numberFormated, format.negativeNumberFormat);
  // }
  // return formatNumber(value, format);
  return number(value, convertFormatNumber(format));
}

/**
 *
 * @param { string } stringValue
 * @param { import("../..").INegativeNumberFormat } formatNegativeNumber
 * @returns { string }
 */
export function formatNegativeNumber(stringValue, formatNegativeNumber) {
  if (!isValidNegativeNumberFormat(formatNegativeNumber)) {
    formatNegativeNumber = "-n";
  }
  return formatNegativeNumber.replace("n", stringValue);
}

export const objectToEnum = ob => {
  const newObject = {};
  for (const [key, value] of Object.entries(ob)) {
    newObject[key] = value;
    newObject[value] = key;
  }

  return newObject;
};

export function isString(item) {
  return Object.prototype.toString.call(item) === "[object String]";
}

export function loadConfiguredCustomStylesheet(settings) {
  loadCustomStylesheet(window.appSettings.customStylesheets, settings?.data?.settings?.styleURI, window.appSettings.customStylesheetUrlBase);
  return settings;
}

export function loadVariableStylesByTemplate(settings) {
  const template = settings?.data?.settings?.template;
  setVariableByTemplate(template, variableStylesCommon, variableStyles).injectTo(document.head, true);
  return settings;
}

export const calcPriceHistory = (prices, initStatus = 1) => {
  const pricesClone = [];
  for (let i = prices.length - 1; i >= 0; i--) {
    if (i === prices.length - 1) {
      pricesClone.unshift({
        ...prices[i],
        priceStatus: initStatus,
      });
      continue;
    }
    const prev = pricesClone[0];
    const current = prices[i];
    const priceStatus = prev.last === current.last ? prev.priceStatus : current.last > prev.last ? 1 : -1;
    pricesClone.unshift({
      ...prices[i],
      priceStatus: priceStatus,
    });
  }

  return pricesClone;
};

export const getKeyTradeHistory = object => {
  return object.time + object.volume;
};

/**
 *
 * @param {number} decimalDigits
 * @returns { string }
 */
export const transitionDecimalDigitsToFormatNumber = (decimalDigits) => {
  let formatNumber = "#,##0.";
  for (let i = 1; i <= decimalDigits; i++) {
    formatNumber += '0'
  }
  return formatNumber
}

export function flattenObjectValues(obj, result = {}) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        flattenObjectValues(obj[key], result);
      } else {
        result[key] = obj[key];
      }
    }
  }
  return result;
}

/**
 *
 * @param {string} name // shareName or tickerName
 * @returns
 */
export function trimAbbreviation(name = '') {
  return name.replace(/ *\([^)]*\) */g, '').trim();
}

export {
  classNames,
  replaceKey,
  clickWithoutMove,
  getRealEventName,
} from "@euroland/libs/utils";
